import { render, staticRenderFns } from "./ChatItemsComponent.vue?vue&type=template&id=6ce79fef&scoped=true&"
import script from "./ChatItemsComponent.vue?vue&type=script&lang=js&"
export * from "./ChatItemsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ChatItemsComponent.vue?vue&type=style&index=0&id=6ce79fef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce79fef",
  null
  
)

export default component.exports